import React from 'react';
import Table, { TableProps } from '@mui/joy/Table';

const orderDashboardTableDefaults: Partial<TableProps> = {
  borderAxis: 'bothBetween',
  hoverRow: true,
  stripe: 'odd',
  size: 'sm',
  variant: 'plain',
  color: 'neutral',
};

const denseTableSx = {
  '--TableCell-paddingY': '0.125rem',
  '--TableCell-paddingX': '0.375rem',
  '--unstable_TableCell-height': '1.875rem',
} as const;

const DashboardTable: React.FC<TableProps> = ({ sx, ...rest }) => (
  <Table
    {...orderDashboardTableDefaults}
    {...rest}
    sx={[denseTableSx, ...(Array.isArray(sx) ? sx : sx ? [sx] : [])]}
  />
);

export default DashboardTable;
